import { HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import CustomInput from 'components/CustomInput/CustomInput';
import React, { useMemo, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentFormStyle';
import getEventValue from 'views/TopUpAddOns/helpers/getEventValue';
import emailNotValid from 'utils/objectsValidation/emailNotValid';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBillingAddressProps {
	formData: types.payment.IFormData;
	setFormData: (name: keyof types.payment.IFormData, value: string) => void;
	validation: types.payment.IValidation;
	setValidation: React.Dispatch<React.SetStateAction<types.payment.IValidation>>;
	errors: types.payment.IErrors;
}

const BillingAddress = ({ formData, setFormData, validation, setValidation, errors }: IBillingAddressProps) => {
	const classes = useStyles();

	useEffect(() => {
		setValidation((validation) => ({
			...validation,
			email: {
				isPotentiallyValid: formData.email.length === 0 || !emailNotValid(formData.email),
				isValid: !emailNotValid(formData.email),
			},
		}));
	}, [formData.email, setValidation]);

	const emailText = useMemo(() => {
		if (formData.email.length === 0) {
			return '';
		} else if (validation.email.isValid) {
			return translate('payments.topup.correctEmail');
		} else {
			return translate('payments.topup.wrongEmail');
		}
	}, [formData.email, validation.email]);

	return (
		<>
			<div className={classes.billingAddress}>
				<HeadingSBold disableMargin>{translate('billingAddress')}</HeadingSBold>
			</div>
			<CustomInput
				labelText={translate('email')}
				formControlProps={{ fullWidth: true }}
				error={errors.email}
				success={formData.email.length !== 0 && validation.email.isValid}
				disableHover
				helperText={emailText}
				id="payment-email"
				inputProps={{
					value: formData.email,
					onChange: (event: types.topUp.FormEvent) =>
						setFormData('email', getEventValue(event).replace(/[ ]+/g, '')),
				}}
			/>
		</>
	);
};

export default BillingAddress;
